import { Button, makeStyles, Tooltip } from '@material-ui/core';
import React from 'react';
import { useDispatch } from 'react-redux';
import { addFilesToAsset } from '../../../redux/actions/manageAssetActions';
import AddCircleIcon from '@material-ui/icons/AddCircle';

const useStyles = makeStyles(() => ({
	displayNone: { display: 'none' },
}));
// Add new source files Btn component for manage asset page.
function AddSourceFilesBtn({ asset }) {
	const classes = useStyles();
	const dispatch = useDispatch();
	// adding files to manage asset state
	const handleFileOnChange = (event) => {
		const files = event.target.files;
		dispatch(addFilesToAsset(asset, files));
	};
	return (
		<div>
			<Tooltip placement="top" arrow={true} title="Click to add source files to this asset">
				<Button
					startIcon={<AddCircleIcon />}
					variant="contained"
					size="large"
					color="primary"
					id="add-files"
					data-cy="add-files"
					component="label"
				>
					<input
						type="file"
						// for M1 release, only .glb source files are accepted.
						accept=".glb"
						data-cy="add-files-input"
						className={classes.displayNone}
						multiple
						onChange={handleFileOnChange}
					/>
					Upload New Source
				</Button>
			</Tooltip>
		</div>
	);
}

export default AddSourceFilesBtn;
